const phasetwoDocs = "https://phasetwo.io/docs";

export const PhaseTwoHelpUrls = {
  orgsUrl: `${phasetwoDocs}/organizations/`,
  stylesUrl: `${phasetwoDocs}/getting-started/customizing-ui`,
};
